import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateVisitInput } from '../types/visit';

// Mock API call - replace with actual API endpoint
async function createVisit(data: CreateVisitInput) {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));

  return {
    id: Math.random().toString(36).substr(2, 9),
    ...data,
    status: 'scheduled',
    endTime: new Date(new Date(data.startTime).getTime() + data.duration * 60000).toISOString(),
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
}

export function useCreateVisit() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createVisit,
    onSuccess: () => {
      // Invalidate visits query to refetch the list
      queryClient.invalidateQueries({ queryKey: ['visits'] });
    },
  });
}
